<script>
    import { currentUser, selectedItem, searchTerm } from '../store/store.js';
    import { handleLogout } from '../utils/login';
    import { Link } from "svelte-routing";

    function clearSelectedItem() {
        searchTerm.set('');
    }
</script>

<div class="top-bar">
    <div class="top-bar-rectangle top-bar-left"></div>
    <div class="top-bar-rectangle top-bar-middle">
        <Link to="/" class="top-bar-link" on:click={clearSelectedItem}>Hem</Link>
        <Link to="/about" class="top-bar-link">Om Oss</Link>
        {#if !$currentUser?.accessToken}
            <Link to="/login" class="top-bar-link">Logga in</Link>
        {:else}
            <Link to="/profile" class="top-bar-link">Profil</Link>
            <button on:click={handleLogout} class="top-bar-link">Logga ut</button>
        {/if}
    </div>
    <div class="top-bar-rectangle top-bar-right"></div>
</div>


<style>
    .top-bar {
  display: flex;
  align-items: flex-start; /* Aligns rectangles to the top */
  justify-content: space-between; /* Distributes space between rectangles */
  width: 100%;
  height: 40px; /* Height of the tallest rectangle */
  background-color: transparent; /* Optional: background color for the top bar */
  position: relative; /* Needed for positioning the triangles */
}

.top-bar-rectangle {
  background-color: var(--primary-color); /* Color of the rectangles */
  position: relative; /* Needed for positioning the triangles */
}

.top-bar-left, .top-bar-right {
  width: 35%; /* Adjust width as needed */
  height: 20px;
  border-bottom: 2px solid var(--top-bar-border); /* Add a bottom border */
}

    .top-bar-middle {
    width: 30%; /* Adjust width as needed */
    min-width: 355px;
    height: 40px;
    border-bottom: 2px solid var(--top-bar-border); /* Add a bottom border */
    display: flex; /* Use flexbox to align links */
    align-items: center; /* Vertically center the links */
    justify-content: center; /* Horizontally center the links */
    gap: 20px; /* Add space between the links */
    }

    .top-bar-left::after {
    content: '';
    position: absolute;
    right: -0px; /* Adjust based on the width of the triangle */
    top: 20px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 20px 0 0; /* Flipped vertically */
    border-color: var(--primary-color) transparent transparent transparent; /* Match the rectangle color */
    z-index: 1; /* Higher z-index to ensure it's above other elements */
    transform: rotate(90deg);
    }

    /* Add a border to the left triangle */
    .top-bar-left::before {
    content: '';
    position: absolute;
    right: 0px; /* Slightly offset to create the border effect */
    top: 21px; /* Slightly offset to create the border effect */
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 21px 21px 0 0; /* Slightly larger than the main triangle */
    border-color: var(--top-bar-border) transparent transparent transparent; /* Border color */
    z-index: 0; /* Place it behind the main triangle */
    transform: rotate(90deg);
    }

    /* Triangle between middle and right (flipped vertically) */
    .top-bar-middle::after {
    content: '';
    position: absolute;
    right: -20px; /* Adjust based on the width of the triangle */
    top: 20px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 20px 20px 0; /* Flipped vertically */
    border-color: transparent var(--primary-color) transparent transparent; /* Match the rectangle color */
    z-index: 1; /* Higher z-index to ensure it's above other elements */
    transform: rotate(270deg);
    }

    /* Add a border to the middle triangle */
    .top-bar-middle::before {
    content: '';
    position: absolute;
    right: -21px; /* Slightly offset to create the border effect */
    top: 21px; /* Slightly offset to create the border effect */
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 21px 21px 0; /* Slightly larger than the main triangle */
    border-color: transparent var(--top-bar-border) transparent transparent; /* Border color */
    z-index: 0; /* Place it behind the main triangle */
    transform: rotate(270deg);
    }

    .top-bar-link {
        color: #b1b1b1; /* Match the rectangle color or use another color */
        text-decoration: none; /* Remove underline from links */
        font-family: 'MuseoModerna'; /* Set a font */
        font-size: 1em;
        font-weight: 600;
    }

    .top-bar-link:hover {
        text-decoration: none;
        color: rgb(75 75 75);
    }

    :global(.top-bar-link) {
        color: #b1b1b1; /* Match the rectangle color or use another color */
        text-decoration: none; /* Remove underline from links */
        font-family: 'MuseoModerna'; /* Set a font */
        font-size: 1em;
        font-weight: 600;
    }

    :global(.top-bar-link:hover) {
        text-decoration: none;
        color: rgb(75 75 75);
    }

    button.top-bar-link {
        background: none; /* Remove default background */
        border: none; /* Remove default border */
        cursor: pointer; /* Change cursor to pointer */
        padding: 0; /* Remove default padding */
        margin: 0; /* Remove default margin */
    }

    @media (max-width: 768px) {
        .top-bar-left, .top-bar-right {
            width: 5%;
        }
        .top-bar-middle {
            width: 90%;
            min-width: 0;
            gap: 10px;
            justify-content: space-evenly;
        }
        .top-bar-link {
            font-size: 1em;
        }
    }
</style>
